import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UNITS, normalizeUnitValue } from '@/lib/units';

export default function UnitSelect({ value, onValueChange, className = '', disabled = false, placeholder = 'Unità', ...props }) {
  return (
    <Select value={normalizeUnitValue(value) || undefined} onValueChange={onValueChange} disabled={disabled} {...props}>
      <SelectTrigger className={className} aria-label={placeholder}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {UNITS.map(unit => <SelectItem key={unit.value} value={unit.value}>{unit.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
